import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import ExploreOtherSitesComponent from './js/explore-other-sites.component';

ComponentsFactory.getInstance().define('explore-other-sites', ExploreOtherSitesComponent);
